import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { queryKeys } from '@/shared/api/queryKeys'
import { fetchSubscriberOverview, type SubscriberOverview } from './subscriberApi'

/** Kartochka har 15 soniyada yangilanadi — sessiya holati tez o'zgaradi. */
export const OVERVIEW_REFRESH_MS = 15_000

/**
 * Abonentning umumiy manzarasi — BITTA so'rov, bir necha iste'molchi.
 *
 * <h2>⚠️ Nega alohida hook bo'ldi</h2>
 * `GET /api/subscribers/{id}/overview` javobi kartochkaning IKKI joyida
 * kerak: "Umumiy manzara" kartasida (balans, tezlik, qoldiq) va "Asosiy
 * ma'lumot" dagi ULANISH belgisida (`activeSessions > 0`).
 *
 * Ilgari ikkinchisi butunlay boshqa so'rovdan chizilardi — tashkilotdagi
 * BARCHA faol sessiyalar ro'yxatidan (`useOnlineLogins`, `limit=500`).
 * Ya'ni bitta abonentning onlayn/oflayn belgisi uchun butun tenant
 * bo'yicha sessiya jadvali tortilardi va u boshqa hech nimaga
 * ishlatilmasdi. Endi javob shu yerdan olinadi: qo'shimcha so'rov ham
 * yo'q, ikki manba bir-biriga zid gapirishi ham.
 *
 * ⚠️ Kalit `queryKeys.subscribers.overview(id)` — chaqiruvchilar sonidan
 * qat'i nazar TanStack Query bitta so'rov yuboradi va bitta kesh yozuvi
 * saqlaydi.
 *
 * @param live `true` bo'lsa 15 soniyada o'zi yangilanadi. Bo'lim ko'rinmay
 *             turganda (`Tabs` boshqa bo'limda) buni `false` qilish shart:
 *             ko'rinmaydigan kartani so'rab turish sof isrof.
 */
export function useSubscriberOverview(
  subscriberId: string,
  live = false,
): UseQueryResult<SubscriberOverview> {
  return useQuery({
    queryKey: queryKeys.subscribers.overview(subscriberId),
    queryFn: () => fetchSubscriberOverview(subscriberId),
    refetchInterval: live ? OVERVIEW_REFRESH_MS : false,
    // Yangilanish davri bilan BIR XIL: bo'limlar orasida yurib qaytganda
    // davr o'rtasida qo'shimcha so'rov ketmasin.
    staleTime: OVERVIEW_REFRESH_MS,
  })
}
